import React, {useState,useEffect, useRef}from 'react';
import { CUSTOM_COMPONENTS } from '../../js/customElements/customComponents';
import { RadioButton, Button } from 'global-components-library';
import { Singleton } from '../../js/Singleton';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { useDispatch, useSelector } from 'react-redux';
import { changeCampaignType } from '../../redux/actions/A_preview';
import { AgentButton } from 'global-components-library';

const language = new Singleton();
const sharedData = new SingletonSharedData();

const CampaignType = ({onClose,onClickSendChangesCampType}) => {
  const initialValue = useRef(sharedData.getDataPreviewPro().dialingMode === 1 ? {previewCamp: 1,defaultCamp: 0} : {previewCamp: 0,defaultCamp: 1});
  const [selected, setSelected] = useState(initialValue.current);
  const currentState = sharedData.getCurrentState().toUpperCase();
  const [disabled, setDisabled] = useState(true);
  const [isTryingToSave, setIsTryingToSave] = useState(false);
  const [preState,setPreState] = useState();
  const [showMsg,setShowMsg] = useState({flag: false, isSaveChangesCorrect: false});
  const [wichMsgShow,setWichMsgShow] = useState(0);
  const [msg,setMsg] = useState('');
  const isTryingToSaveCampTyp= useSelector(state => state.preview.isTryingToChangeCamp);
  const isSuccess= useSelector(state => state.preview.isChangeSuccess);
  const nextCampType = useSelector(state => state.preview.nextCampType);

  const dispatch = useDispatch();

  useEffect(() => {
    if(isTryingToSaveCampTyp && isSuccess) 
    {
      setWichMsgShow(2);
    }else{
      setWichMsgShow(1);
    }
  }, [])
  
  useEffect(() => {
    IsScheduled();
  }, [isSuccess])
  

  useEffect(()=>{

    if(isTryingToSave && showMsg.flag === true && showMsg.isSaveChangesCorrect === true){
      setWichMsgShow(2);
      setIsTryingToSave(false);
    } else if(isTryingToSave && showMsg.flag === true && showMsg.isSaveChangesCorrect === false){
      setWichMsgShow(3);
      setIsTryingToSave(false);
    } 
  },[showMsg])

  useEffect(()=>{ 
    if(selected.previewCamp !== initialValue.current.previewCamp) {
      setDisabled(false);
    }
    else{
      setDisabled(true);
    }   
  },[selected]);

  useEffect(()=>{
    setPreState(sharedData.getCurrentState().toUpperCase());
  },[isTryingToSave]);

  useEffect(()=>{
    if(isTryingToSave)
    {
      if(selected.previewCamp === 1  && preState === 'READY' && currentState === 'READYPREVIEWPRO' )
      {
        //Cambios guardados Ready->ReadyPReview
        setMsg(language.getText("GUIAlertMessagechangePreview"));
        setShowMsg({flag:true,isSaveChangesCorrect:true});
      } 
      else if(selected.previewCamp === 0 && preState === 'READYPREVIEWPRO' && currentState === 'READY' )
      {
        //Cambios guardados ReadyPReview->Ready
        setMsg(language.getText("GUIAlertMessagechangeDefault"));
        setShowMsg({flag:true,isSaveChangesCorrect:true});
        sharedData.setDataPreviewPro(0,sharedData.getDataPreviewPro().allowChangeDialMode);
      }else {
        //No se guardaron cambios
        setShowMsg({flag:true,isSaveChangesCorrect:false})
      }
    }   
  },[currentState]);

  const IsScheduled =()=>{
    if (isTryingToSaveCampTyp && isSuccess)
    {
      let tempMsg = nextCampType === 3 ? language.getText("GUIAlertMessagechangeDefault") : language.getText("GUIAlertMessagechangePreview");
      setMsg(tempMsg);
      setShowMsg({flag:true,isSaveChangesCorrect:true});
    }
  }
  const saveChanges = (opc) => { 
    if(opc.previewCamp !== selected.previewCamp )
    {
      setSelected({previewCamp: opc.previewCamp,defaultCamp: opc.defaultCamp});     
    }
  }
  const sendChanges = () => {
    dispatch(changeCampaignType(true));
    onClickSendChangesCampType(selected.previewCamp);
    setIsTryingToSave(true);
  }
    return (
        <div className={"configBar "}>
        {CUSTOM_COMPONENTS["configCampaignType"](language.getText("GUIPreviewcampaign"), () => onClose())}       
        {(wichMsgShow === 1) && 
        <div className="CampaignTypeContainer"> 
          <p className="subTitleCampaignType">{language.getText("GUIPreviewcampaignTypeSubtitle")}</p>
          <div className="RadioBtnContainer">
            <RadioButton 
              disabled = {false}
              checked = {selected.defaultCamp}
              value={0}
              onChange={()=>saveChanges({previewCamp:0,defaultCamp:1})}
              id={'normal-Campaign'} 
              label={language.getText("GUIPreviewdefaultCamp")} 
              className="StyleRadioBtn"
              />
            <RadioButton  
              disabled = {false}
              checked = {selected.previewCamp}
              value={1}
              onChange={()=>saveChanges({previewCamp:1,defaultCamp:0})}
              id={'preview-Campaign'} 
              label={language.getText("GUIPreviewpreviewCamp")}
              className="StyleRadioBtn" 
              />
             </div>
          <div className="StyleBtnSave">
          <AgentButton type='primary'color={'blue'} onClick={sendChanges} disabled={disabled}>{language.getText("GUIPreviewbtnSave")}</AgentButton>
          </div>
          </div>
          }
          {(wichMsgShow === 2) && 
          <div className="CampaignTypeContainer"> 
          <p className="Msg">{`${language.getText("GUIAlertMessagechangeCampType")} ${msg}`}</p>
          <div className="IconContainer">
          <i id="Correct"className="gcl-icon selected"/>
          </div>   
          </div>
          }
          {(wichMsgShow === 3) && 
          <div className="CampaignTypeContainer"> 
          <p className="Msg">{language.getText("GUIAlertMessageerrorchangeCampType")}</p>
          <div className="IconContainer">
            <i id="InCorrect"className="gcl-icon close-circle "/>
          </div>
          </div>
          }
        </div>
    );
}
export default CampaignType;


// WEBPACK FOOTER //
// ./src/components/Header/CampaignType.jsx